module.exports = __webpack_public_path__ + "img/seasonal-leaf-300.802bd80a.png";